import { atom } from "recoil";

export const iddCollectionSelectedState = atom({
    key: 'iddCollectionSelectedState',
    default: null,
});

export const loadingState = atom({
    key: 'loadingState',
    default: null,
});

export const showResultFormState = atom({
    key: 'showResultFormState',
    default: false,
});

export const sortConfigEntityFileAtom = atom({
    key: 'sortConfigEntityFileAtom', 
    default: null,         
});

export const searchQueryEntityFileAtom = atom({
    key: 'searchQueryEntityFileAtom', 
    default: '', 
});

export const currentPageEntityFileAtom = atom({
    key: 'currentPageEntityFileAtom', 
    default: 1, 
});

export const entiteFileState = atom({
    key:'entiteFileState',
    default: [],       
});

export const statusOpenentiteFileState = atom({
    key:'statusOpenentiteFileState',
    default: {},       
});

export const messageAfficheState = atom({
    key:'messageAfficheState',
    default:''
})



